(ns bp-clients.tv-app.nav.views.initial-page
  "Namespace for the entry page of the app"
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.nav.events :as nav-events]
   [bp-clients.tv-app.nav.views.loading :refer [loading]]
   [bp-clients.tv-app.router :as router]
   [bp-libs.design-system.components.buttons :refer [Button]]
   [bp-libs.design-system.components.icons :refer [bp-logo]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn initial-page []
  (let [main-focus-ref (createRef)
        loading?       (r/atom false)]
    (fn []
      (r/create-class {:component-did-mount (fn [_react-component]
                                              (when-let [main-button main-focus-ref.current]
                                                (.focus main-button)))
                       :reagent-render      (fn [_props]
                                              (if @loading?
                                                [loading]

                                                [:div {:class "text-white text-xl w-full h-full relative min-h-screen"
                                                       :style {:background-image  "linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.50) 30%, rgba(0, 0, 0, 0) 100%), url('https://images.brasilparalelo.com.br/hvzbb2hdx/image/upload/v1/tv_app/initial-page/Landing_BG_2_1.jpg')"
                                                               :background-color  "#134E48"
                                                               :background-repeat "no-repeat"
                                                               :background-size   "cover"
                                                               :background-position "bottom"}}
                                                 [:div {:class "pr-80 pl-60 w-full h-full min-h-screen flex flex-col items-left justify-center"
                                                        :style {:width "65rem"}}
                                                  [bp-logo]
                                                  [:h1 {:class "text-6xl leading-10 font-bold font-serif"
                                                        :style {:font-size   "3.75rem"
                                                                :line-height "4rem"}}
                                                   "Bem-vindo à" [:br]
                                                   "Brasil Paralelo"]
                                                  [:p {:class "mb-20 text-3xl font-medium text-gray-400"}
                                                   "Aqui você tem acesso ao melhor" [:br]
                                                   "de nossas produções e curadoria."]
                                                  [:span {:class "mb-8 text-xl text-center font-medium text-gray-400"}
                                                   "Ainda não é membro?"
                                                   [Button {:react-ref     main-focus-ref
                                                            :tab-index     10
                                                            :color         "black"
                                                            :extra-classes ["w-full mt-2 py-5 round-md justify-center items-center outline-none"]
                                                            :on-click      #(do (reset! loading? true)
                                                                                (rf/dispatch [::nav-events/navigate ::router/register]))}
                                                    "Assine agora"]]
                                                  [Button {:tab-index     10
                                                           :color         "black"
                                                           :extra-classes ["w-full py-5 round-md justify-center items-center outline-none"]
                                                           :on-click      #(do (reset! loading? true)
                                                                               (rf/dispatch [::nav-events/navigate ::router/login]))}
                                                   "Entrar"]]]))}))))
